import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TImePicker from "../../../components/common/TImePicker";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../../Utils/PermissionFunctions";

const Hour = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();

  const [workingHours, setWorkingHours] = useState();
  const [submittedData, setSubmittedData] = [
    {
      vpbx_id: auth.vpbx_id,
      today: "Monday",
      start_time: "",
      end_time: "",
    },
    {
      vpbx_id: auth.vpbx_id,
      today: "Tueasday",
      start_time: "",
      end_time: "",
    },
    {
      vpbx_id: auth.vpbx_id,
      today: "Wednesday",
      start_time: "",
      end_time: "",
    },
    {
      vpbx_id: auth.vpbx_id,
      today: "Thursday",
      start_time: "",
      end_time: "",
    },
    {
      vpbx_id: auth.vpbx_id,
      today: "Friday",
      start_time: "",
      end_time: "",
    },
    {
      vpbx_id: auth.vpbx_id,
      today: "Saturday",
      start_time: "",
      end_time: "",
    },
    {
      vpbx_id: auth.vpbx_id,
      today: "Sunday",
      start_time: "",
      end_time: "",
    },
  ];
  const getWorkingHours = () => {
    let api = "";
    if (auth.role === "2") {
      api = "View_working_hours";
    } else {
      api = "user-View_working_hours";
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setWorkingHours([]);
            } else if (response.data.message === "Data Found") {
              setWorkingHours(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const resetHours = () => {
    axios
      .post(
        url + "update-off-time-status",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Hours have been Updated successfully"
            ) {
              toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    getWorkingHours();
  }, []);

  // useEffect(() => {
  //   if (workingHours !== undefined) {
  //     // setSubmittedData([
  //     //   {
  //     //     vpbx_id: auth.vpbx_id,
  //     //     today: "Monday",
  //     //     start_time: workingHours[0]?.start_time,
  //     //     end_time: workingHours[0]?.end_time,
  //     //   },
  //     // {
  //     //   vpbx_id: auth.vpbx_id,
  //     //   today: "Tueasday",
  //     //   start_time: workingHours[1]?.start_time,
  //     //   end_time: workingHours[1]?.end_time,
  //     // },
  //     // {
  //     //   vpbx_id: auth.vpbx_id,
  //     //   today: "Wednesday",
  //     //   start_time: workingHours[2]?.start_time,
  //     //   end_time: workingHours[2]?.end_time,
  //     // },
  //     // {
  //     //   vpbx_id: auth.vpbx_id,
  //     //   today: "Thursday",
  //     //   start_time: workingHours[3]?.start_time,
  //     //   end_time: workingHours[3]?.end_time,
  //     // },
  //     // {
  //     //   vpbx_id: auth.vpbx_id,
  //     //   today: "Friday",
  //     //   start_time: workingHours[4]?.start_time,
  //     //   end_time: workingHours[4]?.end_time,
  //     // },
  //     // {
  //     //   vpbx_id: auth.vpbx_id,
  //     //   today: "Saturday",
  //     //   start_time: workingHours[5]?.start_time,
  //     //   end_time: workingHours[5]?.end_time,
  //     // },
  //     // {
  //     //   vpbx_id: auth.vpbx_id,
  //     //   today: "Sunday",
  //     //   start_time: workingHours[6]?.start_time,
  //     //   end_time: workingHours[6]?.end_time,
  //     // },
  //     // ]);
  //   }
  // }, [workingHours]);
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>
                {auth.role === "2" && (
                  <p>
                    Use this page to create new call routing, forward calls, set
                    up conference calls, manage existing extensions, and much
                    more.
                  </p>
                )}
              </div>
            </div>

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {(auth.role === "2" || auth.role === "3") && (
                  <>
                    {auth.role === "2" || checkPermissions("ivr-flow") ? (
                      <li
                        onClick={() => navigate("/ivr-flow", { replace: true })}
                      >
                        <a href="#">IVR flow</a>
                      </li>
                    ) : null}

                    {auth.role === "2" || checkPermissions("extensions") ? (
                      <li
                        onClick={() =>
                          navigate("/extensions", { replace: true })
                        }
                      >
                        <a href="#">Extensions</a>
                      </li>
                    ) : null}

                    {auth.role === "2" || checkPermissions("Forwarding") ? (
                      <li
                        onClick={() =>
                          navigate("/call-forwarding", { replace: true })
                        }
                      >
                        <a href="#">Forwarding</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("conferencing") ? (
                      <li
                        onClick={() =>
                          navigate("/call-conferencing", { replace: true })
                        }
                      >
                        <a href="#">Conferencing</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("list-manager") ? (
                      <li
                        onClick={() =>
                          navigate("/list-manager", { replace: true })
                        }
                      >
                        <a href="#">List manager</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("sound-settings") ? (
                      <li
                        onClick={() =>
                          navigate("/sound-setting", { replace: true })
                        }
                      >
                        <a href="#">Sound settings</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("hours") ? (
                      <li
                        className="uk-active"
                        onClick={() => navigate("/hour", { replace: true })}
                      >
                        <a href="#">Hours</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("customized-ivr") ? (
                      <li
                        onClick={() =>
                          navigate("/customized-ivr", { replace: true })
                        }
                      >
                        <a href="#">Customized IVR</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("queue") ? (
                      <li onClick={() => navigate("/queue", { replace: true })}>
                        <a href="#">Queue</a>
                      </li>
                    ) : null}
                    {auth.role === "2" ? (
                      <li onClick={() => navigate("/prompt", { replace: true })}>
                        <a href="#">prompt</a>
                      </li>
                    ) : null}
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {(auth.role === "2" || auth.role === "3") && (
              <>
                {auth.role === "2" || checkPermissions("ivr-flow") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("extensions") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" || checkPermissions("Forwarding") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("conferencing") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" || checkPermissions("list-manager") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("sound-settings") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("hours") ? (
                  <li>
                    <div className="dashboardWrp">
                      <div className="uk-container uk-container-small">
                        <div className="dashboardTop">
                          <div uk-grid="" className="uk-grid uk-grid-small">
                            <div className="uk-width-1-2">
                              <div className="dashboardIntro">
                                <h3>Time Conditions</h3>
                              </div>
                            </div>

                            {(auth.role === "2" ||
                              (auth.role === "3" &&
                                checkIndividualPermission(
                                  "hours",
                                  "read_and_write"
                                ))) && (
                              <div className="uk-width-1-2">
                                <div className="uk-text-right">
                                  <span>
                                    <div className="uk-inline uk-text-left uk-margin-bottom">
                                      <Link
                                        className="exportData-button NewFlow "
                                        onClick={resetHours}
                                        // to={auth.role === "3" ? "/edit-hours" : "/edit-hour"}
                                      >
                                        Reset
                                      </Link>
                                    </div>
                                  </span>
                                  <span>
                                    <div className="uk-inline uk-text-left uk-margin-bottom">
                                      <Link
                                        className="exportData-button NewFlow "
                                        to={
                                          auth.role === "3"
                                            ? "/edit-hours"
                                            : "/edit-hour"
                                        }
                                      >
                                        Edit
                                      </Link>
                                    </div>
                                  </span>
                                  <span className="primary-color"></span>
                                </div>
                              </div>
                            )}
                          </div>

                          <form>
                            <div className="formCreateMain">
                              <div className="uk-grid uk-grid-small">
                                <div className="uk-width-1-1@m uk-margin-top">
                                  <legend className="uk-legend">
                                    Working hours
                                  </legend>
                                </div>
                              </div>
                              {/* <div className="uk-width-1-3@m uk-margin-top">
                  <label>Days</label>
                </div>
                <div className="uk-width-1-3@m uk-margin-top">
                  <label>Start time</label>
                </div>
                <div className="uk-width-1-3@m uk-margin-top">
                  <label>End time</label>
                </div> */}

                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <label className="DateLabel">
                                    <label>Days</label>
                                    <b>Monday</b>
                                  </label>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="startTimeInput">
                                    <label>Start time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      aria-label="Input"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[0]?.start_time
                                          : ""
                                      }
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="endTimeInput">
                                    <label>End time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="07:00 pm"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[0]?.end_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                {workingHours !== undefined &&
                                  workingHours[0]?.option_off_time !== null && (
                                    <div className="uk-width-1-5@m uk-margin-top">
                                      <div className="endTimeInput">
                                        <label>Off-time option</label>
                                        <input
                                          className="uk-input"
                                          type="text"
                                          // value="Play IVR"
                                          aria-label="Input"
                                          disabled
                                          defaultValue={
                                            workingHours !== undefined
                                              ? workingHours[0]?.option_off_time
                                              : null
                                          }
                                        />
                                      </div>
                                    </div>
                                  )}
                                {/* {workingHours !== undefined &&
                  workingHours[0]?.option_off_time !== null &&
                  workingHours[0]?.extensions_number !== null && (
                    <div className="uk-width-1-5@m uk-margin-top">
                      <div className="endTimeInput">
                        <label></label>
                        <br />
                        <input
                          className="uk-input"
                          type="text"
                          // value="IVR1"
                          defaultValue={
                            workingHours !== undefined
                              ? workingHours[0].extensions_number
                              : null
                          }
                          aria-label="Input"
                          disabled
                        />
                      </div>
                    </div>
                  )} */}
                              </div>
                              {/* tuesday */}
                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <label></label> <br />
                                  <label className="DateLabel">
                                    <b>Tuesday</b>
                                  </label>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="startTimeInput">
                                    <label>Start time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="08:00 am"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[1]?.start_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="endTimeInput">
                                    <label>End time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="07:00 pm"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[1]?.end_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                {workingHours !== undefined &&
                                  workingHours[1]?.option_off_time !== null && (
                                    <div className="uk-width-1-5@m uk-margin-top">
                                      <div className="endTimeInput">
                                        <label>Off-time option</label>
                                        <input
                                          className="uk-input"
                                          type="text"
                                          // value="Play IVR"
                                          aria-label="Input"
                                          defaultValue={
                                            workingHours !== undefined
                                              ? workingHours[1]?.option_off_time
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  )}

                                {/* {workingHours !== undefined &&
                  workingHours[1]?.option_off_time !== null &&
                  workingHours[1]?.extensions_number !== null && (
                    <div className="uk-width-1-5@m uk-margin-top">
                      <div className="endTimeInput">
                        <label></label>
                        <br />
                        <input
                          className="uk-input"
                          type="text"
                          // value="IVR1"
                          aria-label="Input"
                          disabled
                          defaultValue={
                            workingHours !== undefined
                              ? workingHours[1].extensions_number
                              : null
                          }
                        />
                      </div>
                    </div>
                  )} */}
                              </div>

                              {/* Wednesday */}
                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <label></label> <br />
                                  <label className="DateLabel">
                                    <b>Wednesday</b>
                                  </label>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="startTimeInput">
                                    <label>Start time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="08:00 am"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[2]?.start_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="endTimeInput">
                                    <label>End time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="07:00 pm"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[2]?.end_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                {workingHours !== undefined &&
                                  workingHours[2]?.option_off_time !== null && (
                                    <div className="uk-width-1-5@m uk-margin-top">
                                      <div className="endTimeInput">
                                        <label>Off-time option</label>
                                        <input
                                          className="uk-input"
                                          type="text"
                                          // value="Play IVR"
                                          aria-label="Input"
                                          defaultValue={
                                            workingHours !== undefined
                                              ? workingHours[2]?.option_off_time
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  )}

                                {/* {workingHours !== undefined &&
                  workingHours[2]?.option_off_time !== null &&
                  workingHours[2]?.extensions_number !== null && (
                    <div className="uk-width-1-5@m uk-margin-top">
                      <div className="endTimeInput">
                        <label></label>
                        <br />
                        <input
                          className="uk-input"
                          type="text"
                          // value="IVR1"
                          aria-label="Input"
                          disabled
                          defaultValue={
                            workingHours !== undefined
                              ? workingHours[2].extensions_number
                              : null
                          }
                        />
                      </div>
                    </div>
                  )} */}
                              </div>
                              {/* thrusday */}
                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <label></label> <br />
                                  <label className="DateLabel">
                                    <b>Thrusday</b>
                                  </label>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="startTimeInput">
                                    <label>Start time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="08:00 am"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[3]?.start_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="endTimeInput">
                                    <label>End time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="07:00 pm"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[3]?.end_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                {workingHours !== undefined &&
                                  workingHours[3]?.option_off_time !== null && (
                                    <div className="uk-width-1-5@m uk-margin-top">
                                      <div className="endTimeInput">
                                        <label>Off-time option</label>
                                        <input
                                          className="uk-input"
                                          type="text"
                                          // value="Play IVR"
                                          aria-label="Input"
                                          defaultValue={
                                            workingHours !== undefined
                                              ? workingHours[3]?.option_off_time
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  )}

                                {/* {workingHours !== undefined &&
                  workingHours[3]?.option_off_time !== null &&
                  workingHours[3]?.extensions_number !== null && (
                    <div className="uk-width-1-5@m uk-margin-top">
                      <div className="endTimeInput">
                        <label></label>
                        <br />
                        <input
                          className="uk-input"
                          type="text"
                          // value="IVR1"
                          aria-label="Input"
                          disabled
                          defaultValue={
                            workingHours !== undefined
                              ? workingHours[3].extensions_number
                              : null
                          }
                        />
                      </div>
                    </div>
                  )} */}
                              </div>
                              {/* Friday */}
                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <label></label> <br />
                                  <label className="DateLabel">
                                    <b>Friday</b>
                                  </label>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="startTimeInput">
                                    <label>Start time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="08:00 am"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[4]?.start_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="endTimeInput">
                                    <label>End time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="07:00 pm"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[4]?.end_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                {workingHours !== undefined &&
                                  workingHours[4]?.option_off_time !== null && (
                                    <div className="uk-width-1-5@m uk-margin-top">
                                      <div className="endTimeInput">
                                        <label>Off-time option</label>
                                        <input
                                          className="uk-input"
                                          type="text"
                                          // value="Play IVR"
                                          aria-label="Input"
                                          defaultValue={
                                            workingHours !== undefined
                                              ? workingHours[4]?.option_off_time
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  )}

                                {/* {workingHours !== undefined &&
                  workingHours[4]?.option_off_time !== null &&
                  workingHours[4]?.extensions_number !== null && (
                    <div className="uk-width-1-5@m uk-margin-top">
                      <div className="endTimeInput">
                        <label></label>
                        <br />
                        <input
                          className="uk-input"
                          type="text"
                          // value="IVR1"
                          aria-label="Input"
                          disabled
                          defaultValue={
                            workingHours !== undefined
                              ? workingHours[4].extensions_number
                              : null
                          }
                        />
                      </div>
                    </div>
                  )} */}
                              </div>
                              {/* Saturday */}
                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <label></label> <br />
                                  <label className="DateLabel">
                                    <b>Saturday</b>
                                  </label>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="startTimeInput">
                                    <label>Start time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="08:00 am"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[5]?.start_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="endTimeInput">
                                    <label>End time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="07:00 pm"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[5]?.end_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                {workingHours !== undefined &&
                                  workingHours[5]?.option_off_time !== null && (
                                    <div className="uk-width-1-5@m uk-margin-top">
                                      <div className="endTimeInput">
                                        <label>Off-time option</label>
                                        <input
                                          className="uk-input"
                                          type="text"
                                          // value="Play IVR"
                                          aria-label="Input"
                                          defaultValue={
                                            workingHours !== undefined
                                              ? workingHours[5]?.option_off_time
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  )}

                                {/* {workingHours !== undefined &&
                  workingHours[5]?.option_off_time !== null &&
                  workingHours[5]?.extensions_number !== null && (
                    <div className="uk-width-1-5@m uk-margin-top">
                      <div className="endTimeInput">
                        <label></label>
                        <br />
                        <input
                          className="uk-input"
                          type="text"
                          // value="IVR1"
                          aria-label="Input"
                          disabled
                          defaultValue={
                            workingHours !== undefined
                              ? workingHours[5].extensions_number
                              : null
                          }
                        />
                      </div>
                    </div>
                  )} */}
                              </div>
                              {/* Sunday */}
                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <label></label> <br />
                                  <label className="DateLabel">
                                    <b>Sunday</b>
                                  </label>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="startTimeInput">
                                    <label>Start time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="08:00 am"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[6]?.start_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                <div className="uk-width-1-5@m uk-margin-top">
                                  <div className="endTimeInput">
                                    <label>End time</label>
                                    <input
                                      className="uk-input"
                                      type="text"
                                      // value="07:00 pm"
                                      defaultValue={
                                        workingHours !== undefined
                                          ? workingHours[6]?.end_time
                                          : ""
                                      }
                                      disabled
                                      aria-label="Input"
                                    />
                                  </div>
                                </div>
                                {workingHours !== undefined &&
                                  workingHours[6]?.option_off_time !== null && (
                                    <div className="uk-width-1-5@m uk-margin-top">
                                      <div className="endTimeInput">
                                        <label>Off-time option</label>
                                        <input
                                          className="uk-input"
                                          type="text"
                                          // value="Play IVR"
                                          aria-label="Input"
                                          defaultValue={
                                            workingHours !== undefined
                                              ? workingHours[6]?.option_off_time
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  )}

                                {/* {workingHours !== undefined &&
                  workingHours[6]?.option_off_time !== null &&
                  workingHours[6]?.extensions_number !== null && (
                    <div className="uk-width-1-5@m uk-margin-top">
                      <div className="endTimeInput">
                        <label></label>
                        <br />
                        <input
                          className="uk-input"
                          type="text"
                          // value="IVR1"
                          aria-label="Input"
                          disabled
                          defaultValue={
                            workingHours !== undefined
                              ? workingHours[6].extensions_number
                              : null
                          }
                        />
                      </div>
                    </div>
                  )} */}
                              </div>
                              <div className="uk-grid " uk-grid="">
                                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                                  {/* <div className="formActionBtn uk-text-right">
                    <button className="whiteBtn">Cancel</button>
                    <button className="pinkBtn">Save</button>
                  </div> */}
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </li>
                ) : null}

                {auth.role === "2" || checkPermissions("customized-ivr") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("queue") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" ? <li></li> : null}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Hour;
